module.exports = __webpack_public_path__ + "img/1562031477.eebc39bb.jpg";